"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteDto = void 0;
class SiteDto {
    constructor(site) {
        this.id = site.id;
        this.parentId = site.parentId;
        this.name = site.name;
    }
}
exports.SiteDto = SiteDto;
